class OrderUtils {

    static prepareOrderBeforeSave (settings, order) {
        let dishesList = []
        let prepareOrder = Object.assign({}, order)
        if (prepareOrder.dishes_list.length > 0) {
            let hArr = []
            prepareOrder.dishes_list.forEach((dish) => {
                let cacheHours = Number(dish.time_preparing.split(":")[0])
                let cacheMinutes = Number(dish.time_preparing.split(":")[1])
                hArr.push((cacheHours * 3600) + (cacheMinutes * 60)) // пишем в массив для последующего сравнения
                dishesList.push({id: dish.id, quantity: dish.quantity})
            })
            let totalMinutes = Math.max.apply(null, hArr) + settings[1].value * 60
            let stopDate = new Date()
            stopDate.setHours(stopDate.getHours() + Math.floor(totalMinutes / 3600))
            stopDate.setMinutes(stopDate.getMinutes() + Math.floor(totalMinutes % 3600 / 60))
            prepareOrder.time_preparing = stopDate
        }
        prepareOrder.dishes_list = dishesList
        delete prepareOrder.time
        delete prepareOrder.timeCount
        delete prepareOrder.timeStatus

        return prepareOrder
    }
}

export const orderUtils = OrderUtils
